import React from 'react';
import { connect } from 'react-redux';
import { compose } from 'redux';
import { Field, reduxForm } from 'redux-form';

import { RadioButtonGroup } from 'redux-form-material-ui';
import { SelectField } from 'redux-form-material-ui';

import { RadioButton } from 'material-ui/RadioButton';
import MenuItem from 'material-ui/MenuItem';

import landlordTenantsReducer from 'reducers/landlordTenantsReducer';

import TenantResidentVerbiageHelper from 'components/shared/TenantResidentVerbiageHelper';

import * as validator from 'helpers/Validator';
import { colors } from 'helpers/ColorHelper';
import { hostIsCarrington } from 'helpers/CurrentWindowLocation';

let AllowTenantsYearlyRenewalsWizardPage = props => {
  const {
    handleSubmit,
    showN1Questions,
    showN1NextQuestion,
    displayN1NextQuestion,
    hideN1NextQuestion,
    onlyShowYearly,
  } = props;

  const renderError = ({ meta: { touched, error } }) =>
    touched && error ? (
      <p style={{ color: colors.RED, fontSize: '11px', textAlign: 'center' }}>{error}</p>
    ) : (
      false
    );
  return (
    <div>
      <form onSubmit={handleSubmit}>
        <h3 style={{ textAlign: 'center' }}>
          {' '}
          <TenantResidentVerbiageHelper capitalize /> Renewal Options.{' '}
        </h3>
        <div className="row" style={{ marginTop: '15px' }}>
          <div style={{ textAlign: 'center' }}>
            <div style={{ fontSize: '14px' }}>
              Some jurisdictions have certain laws and regulations dictating whether{' '}
              <TenantResidentVerbiageHelper />s must renew on a yearly lease, month-to-month, or
              either/or. If you are unsure, feel free to reach out to us on our live-chat by
              clicking on the blue help button in the top right corner.
            </div>
          </div>
          <div style={{ marginTop: '15px', width: '300px', margin: 'auto' }}>
            <Field
              name="tenant_renewal_options"
              floatingLabelText={
                <span>
                  <TenantResidentVerbiageHelper capitalize /> Renewal Option(s)
                </span>
              }
              validate={[validator.required]}
              component={SelectField}
              style={{ width: '100%', margin: 'auto', fontSize: '14px' }}
            >
              {(!onlyShowYearly || hostIsCarrington()) && (
                <MenuItem value={'Month to Month'} primaryText={'Month to Month'} />
              )}
              <MenuItem value={'Yearly'} primaryText={'Yearly'} />
            </Field>
          </div>
        </div>

        {showN1Questions && (
          <div>
            <h3 style={{ textAlign: 'center', marginTop: '35px' }}>
              {' '}
              Notice of Rent Increase - N1.{' '}
            </h3>
            <div className="row" style={{ marginTop: '15px' }}>
              <div style={{ textAlign: 'center', marginTop: '20px' }}>
                <div style={{ fontSize: '14px' }}>
                  Is this rent increase more than the rent increase guideline?
                </div>
              </div>
              <div className="col-sm-12" style={{ textAlign: 'center', marginTop: '15px' }}>
                <Field
                  name="more_than_guideline"
                  component={RadioButtonGroup}
                  onChange={(event, value) => {
                    if (value === 'true') {
                      displayN1NextQuestion();
                    } else {
                      hideN1NextQuestion();
                    }
                  }}
                  style={{ width: '187px', margin: 'auto' }}
                >
                  <RadioButton
                    value="true"
                    label="Yes"
                    style={{ width: '102px', display: 'inline-flex' }}
                  />
                  <RadioButton
                    value="false"
                    label="No"
                    style={{
                      width: '70px',
                      display: 'inline-flex',
                      float: 'right',
                    }}
                  />
                </Field>
                <Field
                  name="more_than_guideline"
                  validate={[validator.required]}
                  component={renderError}
                />
              </div>
            </div>

            {showN1NextQuestion && (
              <div className="row">
                <div style={{ textAlign: 'center', marginTop: '10px' }}>
                  <div style={{ fontSize: '14px' }}>
                    Has this rent increase been approved by an order under the Residential Tenancies
                    Act, 2006?
                  </div>
                </div>
                <div className="col-sm-12" style={{ textAlign: 'center', marginTop: '15px' }}>
                  <Field
                    name="has_been_approved"
                    component={RadioButtonGroup}
                    style={{ width: '187px', margin: 'auto' }}
                  >
                    <RadioButton
                      value="true"
                      label="Yes"
                      style={{ width: '102px', display: 'inline-flex' }}
                    />
                    <RadioButton
                      value="false"
                      label="No"
                      style={{
                        width: '70px',
                        display: 'inline-flex',
                        float: 'right',
                      }}
                    />
                  </Field>
                  <Field
                    name="has_been_approved"
                    validate={[validator.required]}
                    component={renderError}
                  />
                </div>
              </div>
            )}
          </div>
        )}
      </form>
    </div>
  );
};

const mapStateToProps = (state, ownProps) => {
  return {
    form: ownProps.name,
  };
};

AllowTenantsYearlyRenewalsWizardPage = compose(
  connect(mapStateToProps),
  reduxForm({
    destroyOnUnmount: false, // <------ preserve form data
    forceUnregisterOnUnmount: true, // <------ unregister fields on unmount
  })
)(AllowTenantsYearlyRenewalsWizardPage);

AllowTenantsYearlyRenewalsWizardPage = connect(
  state => ({
    initialValues: state.landlordTenants.leaseDetails, // pull initial values from account reducer
  }),
  { load: landlordTenantsReducer } // bind account loading action creator
)(AllowTenantsYearlyRenewalsWizardPage);

export default AllowTenantsYearlyRenewalsWizardPage;
